import React, { useEffect, useState } from 'react';

import { Checkbox, FormControlLabel, Grid, makeStyles, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles((theme) => {
  return {
    buttonContainer: {
      maxWidth: '100%',
      [theme.breakpoints.up('md')]: {
        maxWidth: '200px',
      },
    },
    checkboxContainer: {
      marginTop: '16px',
    },
    container: {
      marginTop: '20px',
    },
    link: {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
      textDecoration: 'none',
    },
    typographyLabel: {
      color: '#999999',
      fontSize: '14px',
      lineHeight: '20px',
      transform: 'translateY(2px)',
    },
    typographyWarning: {
      color: '#dd5555',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '16px',
      marginTop: '12px',
      textAlign: 'left',
    },
  };
});
export default ({ status, onChangeFormStatus, onCancel, onSubmit, isSubmitting$, submitButtonError = '' }) => {
  const classes = useStyles();
  const [termsCheck, setTermsCheck] = useState(false);
  const [btnEnabled, setBtnEnabled] = useState(false);

  useEffect(() => {
    setBtnEnabled(status.isBtnEnabled && status.isBtnEnabled());
    setTermsCheck(status.formStatus.termsCheck);
  }, [status]);

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={12}>
            <div className={classes.checkboxContainer} style={{ textAlign: 'left' }}>
              <FormControlLabel
                classes={{ root: 'mediphany-formcontrol-root' }}
                control={
                  <Checkbox
                    classes={{ root: 'mediphany-checkbox-root' }}
                    value={termsCheck}
                    onChange={(event) => onChangeFormStatus(event.target.checked, 'termsCheck')}
                    size="medium"
                    name="checkedB"
                    color="primary"
                  />
                }
                label={
                  <Typography className={`${classes.typographyLabel} text-left`}>
                    I have read, understand and agree to Mediphany’s&nbsp;
                    <a href="https://mediphany.com/terms-and-conditions/" className={classes.link} target="_blank" rel="noreferrer">
                      Terms of Service
                    </a>
                    &nbsp;and&nbsp;
                    <a href="https://mediphany.com/privacy-policy/" className={classes.link} target="_blank" rel="noreferrer">
                      Privacy Policy
                    </a>
                    .
                  </Typography>
                }
              />
            </div>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} container spacing={2} justify="flex-start">
        <Grid item xs={12}>
          <div className={classes.buttonContainer}>
            <LoadingButton
              disabled={!btnEnabled}
              variant="contained"
              color="primary"
              style={{ margin: '28px 0 12px', padding: '12px', width: '100%' }}
              onClick={onSubmit}
              loading$={isSubmitting$}>
              Submit Request
            </LoadingButton>
          </div>

          {submitButtonError ? <Typography className={classes.typographyWarning}>{submitButtonError}</Typography> : null}
        </Grid>
      </Grid>
    </Grid>
  );
};
